// extracted by mini-css-extract-plugin
export default {"checkmarks":"Checkmarks_checkmarks__tefEv","correct":"Checkmarks_correct__WK-y0","bump":"Checkmarks_bump__+a2dv","incorrect":"Checkmarks_incorrect__aLQsw"};